import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { GOOGLE_WEB_CLIENT_ID } from '../config/runtimeConfig';

let nativeGoogleInitialized = false;

export const isNativeGoogleAuthSupported = () =>
  Capacitor.isNativePlatform() && ['android', 'ios'].includes(Capacitor.getPlatform());

const getGoogleClientId = () => String(GOOGLE_WEB_CLIENT_ID || '').trim();

const ensureNativeGoogleInitialized = async () => {
  if (nativeGoogleInitialized) {
    return;
  }

  const webClientId = getGoogleClientId();
  if (!webClientId) {
    throw new Error('Google web client ID is missing. Set REACT_APP_GOOGLE_CLIENT_ID_WEB* (or REACT_APP_GOOGLE_CLIENT_ID).');
  }

  await SocialLogin.initialize({
    google: {
      webClientId,
      mode: 'online',
    },
  });

  nativeGoogleInitialized = true;
};

export const signInWithNativeGoogle = async () => {
  if (!isNativeGoogleAuthSupported()) {
    return null;
  }

  await ensureNativeGoogleInitialized();

  const response = await SocialLogin.login({
    provider: 'google',
  });

  const idToken = response?.result?.idToken || '';
  if (!idToken) {
    throw new Error('Google sign-in did not return an ID token.');
  }

  return {
    idToken,
    profile: response?.result?.profile || null,
  };
};
